import React from 'react';
import { TextLog } from 'modules/emergencies/components/ui/texts/LogText';
import { LogTitleContainer } from '../../ui/containers/logTitleContainer';
import LogIcon from 'modules/emergencies/components/log/LogIcon';

const TicketLogTitleCarrier = ({ title, icon }) => {
  return (
    <LogTitleContainer>
      <LogIcon icon={icon} />
      <TextLog color="#263340">{title}</TextLog>
      {<TextLog color="#54708C">/ Carrier</TextLog>}
    </LogTitleContainer>
  );
};

export default TicketLogTitleCarrier;
